export const IntegrationsInInsert = {
  flow: 'y',
  gap: 'A',
  position: 'relative',
  CaptionTitle: {
    Text: {
      text: '{{ apps.integrations.title | polyglot }}'
    }
  },
  Flex: {
    gap: 'A',
    flow: 'y',
    margin: '- -Z2',
    childExtends: 'IntegrationsItem',
    childrenAs: 'state',
    children: () =>
      [
        {
          icon: 'github',
          title: 'Github',
          descr: 'apps.integration.github.descr'
        },
        {
          icon: 'slack',
          title: 'Slack',
          descr: 'apps.integration.slack.descr'
        },
        {
          icon: 'intercom',
          title: 'Intercom',
          descr: 'apps.integration.intercom.descr'
        },
        {
          // Amplitude has no simple-icons entry (checked, not in the
          // catalog) — kept on its nearest REGISTERED category glyph rather
          // than an unvetted/hand-traced mark, per tickets/fable.md
          // "commission ~12 real brand-mark SVGs": a deliberate, documented
          // fallback beats a silently-wrong or unlicensed asset. Still owed.
          icon: 'analytics',
          title: 'Amplitude',
          descr: 'apps.integration.amplitude.descr'
        },
        {
          icon: 'googleAnalytics',
          title: 'Google Analytics',
          descr: 'apps.integration.googleAnalytics.descr'
        },
        {
          icon: 'stripe',
          title: 'Stripe',
          descr: 'apps.integration.stripe.descr'
        },
        {
          icon: 'auth0',
          title: 'Auth0',
          descr: 'apps.integration.auth0.descr'
        },
        {
          icon: 'googleSheets',
          title: 'Google Sheets',
          descr: 'apps.integration.googleSheets.descr'
        },
        {
          icon: 'instagram',
          title: 'Instagram feed',
          descr: 'apps.integration.instagram.descr'
        },
        {
          icon: 'npm',
          title: 'NPM',
          descr: 'apps.integration.npm.descr'
        },
        {
          icon: 'firebase',
          title: 'Firebase',
          descr: 'apps.integration.firebase.descr'
        }
      ].slice(0, 5)
  },
  InsertSectionShadow: {}
}
